import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Menu.css';

function MenuItemLink({ item, className, onClick }) {
  if (item.type === 'action') {
    return (
      <button type="button" className={`${className} menu__action`} onClick={onClick || item.onClick}>
        {item.label}
      </button>
    );
  }

  if (item.type === 'external') {
    return (
      <a href={item.href} className={className} target="_blank" rel="noreferrer" onClick={onClick}>
        {item.label}
      </a>
    );
  }

  if (item.type === 'nav') {
    return (
      <NavLink to={item.to} className={className} onClick={onClick}>
        {item.label}
      </NavLink>
    );
  }

  if (item.type === 'link') {
    return (
      <Link to={item.to} className={className} onClick={onClick}>
        {item.label}
      </Link>
    );
  }

  return <span className="menu__meta">{item.label}</span>;
}

export default function FullScreenMenu({
  homeTo = '/',
  logoSrc,
  logoAlt = 'Logo',
  brandKicker = 'Brand',
  brandText = '',
  primaryItems = [],
  secondaryItems = [],
}) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousTouchAction = document.body.style.touchAction;

    if (open) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    }

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.touchAction = previousTouchAction;
    };
  }, [open]);

  const closeMenu = () => setOpen(false);
  const toggleMenu = () => setOpen((value) => !value);



  return (
    <>
      <button
        type="button"
        className={`burger ${open ? 'burger--close' : ''}`}
        onClick={toggleMenu}
        aria-label={open ? 'メニューを閉じる' : 'メニューを開く'}
        aria-expanded={open}
        aria-controls="fullscreen-menu"
      >
        <span className="burger__patty" />
        <span className="burger__patty" />
        <span className="burger__patty" />
      </button>

      <nav id="fullscreen-menu" className={`menu ${open ? 'menu--active' : ''}`} aria-hidden={!open}>
        <div className={`menu__brand ${open ? 'menu__brand--active' : ''}`}>
          <NavLink to={homeTo} className="menu__brand-home" onClick={closeMenu} aria-label={logoAlt}>
            <span className="menu__logo-ring">
              {logoSrc ? <img src={logoSrc} alt={logoAlt} className="menu__logo" /> : <div className="logo" />}
            </span>
          </NavLink>
        </div>

        <div className={`menu__list ${open ? 'menu__list--active' : ''}`}>
          <ul className="menu__list-group menu__list-group--primary">
            {primaryItems.map((item, index) => (
              <li key={`${item.label}-${item.to || item.href || index}`} className={`menu__item ${open ? 'menu__item--active' : ''}`}>
                <MenuItemLink item={item} className="menu__link" onClick={closeMenu} />
              </li>
            ))}
          </ul>

          {secondaryItems.length ? (
            <ul className="menu__list-group menu__list-group--secondary">
              {secondaryItems.map((item, index) => (
                <li key={`${item.label}-${item.to || item.href || index}`} className={`menu__item ${open ? 'menu__item--active' : ''}`}>
                  <MenuItemLink item={item} className="menu__link menu__link--secondary" onClick={() => { item.onClick?.(); closeMenu(); }} />
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </nav>
    </>
  );
}
